import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MobilePageMapperService {
  private routesMap = new Map<string, string>(
    [
      ['/shipments/create', '/mobile/shipments/create'],
      ['/shipments/list', '/mobile/shipments/list'],
      ['/not-found', '/mobile/not-found'],
    ]
  );

  get(route: string) {
    const path = route.split('?')[0];
    const directMatch = this.routesMap.get(path);
    if (directMatch) {
      return directMatch;
    }

    const editMatch = path.match(/^\/shipments\/([^/]+)\/edit$/);
    if (editMatch) {
      return `/mobile/shipments/${editMatch[1]}/edit`;
    }

    const detailMatch = path.match(/^\/shipments\/([^/]+)\/details$/);
    if (detailMatch) {
      return `/mobile/shipments/${detailMatch[1]}/details`;
    }

    const byTrackingMatch = path.match(/^\/shipments\/by-tracking\/([^/]+)$/);
    if (byTrackingMatch) {
      return `/mobile/shipments/by-tracking/${byTrackingMatch[1]}`;
    }

    return undefined;
  }
}
